import service from "@/store/services/customers-service";

export const state = () => ({
  list: {},
  contacts: {},
  customer: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, customer) => {
    state.customer = customer;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_CONTACTS: (state, contacts) => {
    state.contacts = contacts;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((customer) => {
      commit("SET_RESOURCE", customer);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((customer) => {
      commit("SET_RESOURCE", customer);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((customer) => {
      commit("SET_RESOURCE", customer);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  customer: (state) => state.customer,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((customer) => ({
      id: customer.id,
      name: `${customer.customer_name}`,
    }));
  },
};

const customers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default customers;
